import { PRICE_FLOOR_EURO } from '@ensemble.music/core'
import {
  CalendarCheck,
  Euro,
  Inbox,
  type LucideIcon,
  Music,
  UserPlus,
  Video,
  Wallet,
} from 'lucide-react'
import type { Step } from '../landingpage/content'

// Copy for /fuer-bands. Every claim here has to hold today: "kostenlos" is BUSINESS_CASE.md
// ("Bands zahlen zunächst nichts"), the floor is the CHECK constraint. No numbers we cannot back.

export const SIGNUP_HREF = '/fuer-bands/anmelden'

export const bandHero = {
  overline: 'Für Bands und Ensembles',
  // three short sentences, each kept on one line - the global hyphens: auto split "Um-satz"
  headline: ['Mehr Auftritte.', 'Mehr Umsatz.', 'Weniger Akquise.'],
  subline:
    'Paare, Firmen und Locations fragen bei ensemble Live-Musik an. Wir schlagen euch für die Anfragen vor, die zu eurem Termin, eurer Besetzung und eurem Preis passen.',
  button: 'Band eintragen',
  secondary: "So funktioniert's",
  checks: ['Kostenlos, ohne Abo', 'Kein Account nötig', 'In drei kurzen Schritten'],
  /** Free Unsplash photo (owner, 2026-10-19), the same file as the Empfang card on /buchen. */
  image: '/images/landing/jazz-combo-900.jpg',
}

/** Labelled as an example on the page - it is not a real request. */
export const exampleRequest = {
  label: 'Beispiel-Anfrage',
  rows: [
    ['Anlass', 'Hochzeit'],
    ['Termin', 'Samstag, Juni'],
    ['Ort', 'Stuttgart'],
    ['Besetzung', 'Duo oder Quartett'],
  ] as const,
}

export const bandBenefits: { icon: LucideIcon; title: string; body: string }[] = [
  {
    icon: Inbox,
    title: 'Mehr Auftritte',
    body: 'Anfragen von Paaren, Firmen und Locations aus der Region, ohne dass ihr selbst Werbung schalten müsst.',
  },
  {
    icon: Wallet,
    title: 'Mehr Umsatz',
    body: `Ihr legt euren Preis fest. Unter ${PRICE_FLOOR_EURO} € vermitteln wir nichts, Dumpingpreise haben hier keinen Platz.`,
  },
  {
    icon: CalendarCheck,
    title: 'Freie Termine füllen',
    body: 'Tragt ein, wann ihr Zeit habt. Wir schlagen euch genau für diese Termine vor.',
  },
  {
    icon: Euro,
    title: 'Für euch kostenlos',
    body: 'Keine Anmeldegebühr, kein Abo, kein Account. Alles läuft per E-Mail.',
  },
]

export const bandSteps: Step[] = [
  {
    title: 'Eintragen',
    icon: UserPlus,
    body: 'Kontakt, ein freier Termin und eure Gage. Das dauert nicht lange.',
  },
  {
    title: 'Prüfen',
    icon: Video,
    body: 'Wir schauen uns euer Video an und melden uns per E-Mail.',
  },
  {
    title: 'Spielen',
    icon: Music,
    body: 'Passt eine Anfrage, schlagen wir euch vor. Ihr sagt zu oder ab.',
  },
]

export const bandFaq = [
  {
    q: 'Was kostet die Anmeldung?',
    a: 'Nichts. Es gibt keine Anmeldegebühr und kein Abo.',
  },
  {
    q: 'Brauchen wir einen Account?',
    a: 'Nein. Ihr tragt euch einmal ein, alles Weitere läuft per E-Mail.',
  },
  {
    q: 'Wer sieht unsere Angaben?',
    a: 'Zuerst nur wir. Ein Booker sieht eure Band erst, wenn wir euch für seine Anfrage vorschlagen.',
  },
  {
    q: 'Gibt es eine Mindestgage?',
    a: `Ja, ${PRICE_FLOOR_EURO} € pro Auftritt. Darunter vermitteln wir nicht.`,
  },
  {
    q: 'Was passiert nach der Anmeldung?',
    a: 'Wir prüfen euren Eintrag persönlich und melden uns per E-Mail. Bis zur Freigabe schlagen wir euch nicht vor.',
  },
]
